export default class KillPigConfigVO {
    public OpenKillPig: boolean = false;
    /**
     * 头部保留轮
     */
    public HeaderReserveJuNumber: number = 1;
    /**
     * 搜索索引
     */
    public SearchStartIndex: number = 0;
    /**
     * 忽略轮
     */
    public IgnoreJuNumber: number = 1;
    /**
     * 尾部保留轮
     */
    public EndReserveJuNumber: number = 2;
    /**
     * 多少钱开始启用
     * 0不限制
     */
    public KillStartAmount: number = 0;
    /**
     * 是否允许复用：被当作跳转目标用过的锚点（IsUsed=true）能否再次进入候选。
     * false = 用过即彻底作废；true（默认）= 熬过下面的使用冷却即可再用。
     * 服务端默认值来自环境变量 KILLPIG_ANCHOR_REUSE_ENABLED，遥控器可随时改（仅当前进程生命周期）。
     */
    public AnchorReuseEnabled: boolean = true;
    /**
     * 使用冷却（秒）：某局只要“播到了”（自然播放经过 / 跳转到达 / 跳转后继续播放经过）
     * 就记录当前播放时间，冷却期内不再作为跳转目标 —— 避免“刚播完立马又播”。
     * 与 AnchorReuseEnabled 无关，无论开关如何都生效。
     * 服务端默认值来自环境变量 KILLPIG_ANCHOR_REUSE_COOLDOWN_SECONDS（默认 60 秒）。
     */
    public AnchorReuseCooldownSeconds: number = 60;
    /**
     * 复用闸门：同一主结果类型（庄/闲/和）当前**可复用**的局数低于该值时，本轮禁止复用该类型。
     * 可复用局 = 已用作跳转目标、且已熬过使用冷却、当前能再次被选中的局。
     * 可复用局只剩 1~2 局时，复用会在冷却到期后反复挑同几局，画面排列高度重复。
     * 0 = 不限制（关闭闸门）。服务端默认值来自环境变量 KILLPIG_ANCHOR_REUSE_MIN_FRESH_COUNT（默认 5）。
     */
    public AnchorReuseMinFreshCount: number = 5;
    /**
     * 随机选局：从“庄家不亏（净收益>0）”的候选里随机挑，避免跳转序列固定（1,2,3,4,5 反复出现）。
     * 服务端默认值来自环境变量 KILLPIG_ANCHOR_RANDOM_PICK（默认开启）。
     */
    public AnchorRandomPickEnabled: boolean = true;
    /**
     * 新批次不干预
     */
    public SkipKillInNewGame: boolean = true;

    /**
     * 自动下注（真实下注）总开关，默认关闭；由遥控器“服务配置-保存”在内存中开启，重启后回到关闭
     */
    public AutoBetEnabled: boolean = false;
    /**
     * 自动下注间隔（分钟），默认 8
     */
    public AutoBetIntervalMin: number = 8;
    /**
     * 自动下注单注金额（庄或闲单边），默认 100
     */
    public AutoBetAmount: number = 100;

    /**
     * 拉取数据总开关：控制是否连接上游 WebSocket（接收游戏/视频链接数据）以及是否拉取并自动重试视频链接。
     * 默认开启；由遥控器“服务配置-保存”在内存中控制。关闭后断开全部数据连接，等待再次开启。
     */
    public PullDataEnabled: boolean = true;

    /**
     * 真实服务器账号余额（来自自动下注连接的 onUserInfo，实时刷新），仅供遥控器展示
     */
    public RealServerBalance: number = 0;

    /**
     * 遥控器调整账号金额后，是否向该账号的在线客户端推送最新余额（走打赏 onGiveTips 通道）。
     * 默认关闭：调额仅落库，客户端需重新登录才看到新余额；开启后即时推送使其余额实时刷新。
     */
    public PushBalanceOnAdjust: boolean = false;

    /**
     * 新账号首次入库时是否把上游当前余额写入数据库。默认开启；关闭后新账号余额置 0 入库。
     */
    public SaveNewUserBalance: boolean = true;

    /**
     * 检测到调试器时是否立即关闭浏览器。默认开启；
     * 关闭后客户端只上报调试器状态，不关闭浏览器。
     */
    public CloseOnDebugger: boolean = true;

    /**
     * 插件版本号门槛开关：默认不限制。
     * 开启后，插件专用接口（长连接 /ws/device、/api/auth/verify、/api/auth/device-status、
     * /api/line/current、/api/device/* 以及 /api/game/balance、bet-* 等业务转发）都要校验版本号，
     * 未上报或低于 RequiredExtVersion 的会被 403 拒绝；
     * 遥控器自己的接口（/api/game/account-stats、user-list、set-amount 等）不受影响。
     * 服务端默认值来自环境变量 KILLPIG_REQUIRE_EXT_VERSION，遥控器保存后立即生效。
     */
    public RequireExtVersion: boolean = false;

    /**
     * 插件最低版本号（开关开启后生效）：按数字逐段比较（2.0.10 > 2.0.9），留空=只要求上报。
     * 服务端默认值来自环境变量 KILLPIG_REQUIRED_EXT_VERSION，默认 2.0.1。
     */
    public RequiredExtVersion: string = '2.0.1';

    /**
     * 重名主播是否禁用托管：同一主播同时出现在 ≥2 个受控房间时，禁止其所在房间托管。
     * 与「智能清理」二选一，默认走智能清理 ⇒ 默认关闭。
     * 服务端默认值来自环境变量 KILLPIG_NO_HOSTING_ON_DUP_DEALER（默认关闭）。
     */
    public NoHostingOnDuplicateDealer: boolean = false;

    /**
     * 智能清理（主播换桌跨房清锚点）：某房间换主播时，按 did/主播名扫描所有房间，
     * 清掉同一主播在其他房间的历史锚点（旧桌残留）。
     * 与「重名避让」（NoHostingOnDuplicateDealer）二选一，开启后不再做重名避让。
     * 服务端默认值来自环境变量 KILLPIG_SMART_ANCHOR_CLEAN（默认开启）。
     */
    public SmartAnchorClean: boolean = true;
}